enum AppSetting {
    ModuleDefault = 'MODULE_DEFAULT',
    ModuleOrder = 'MODULE_ORDER',
    GdprAllow = 'GDPR_ALLOW',
    GdprDecln = 'GDPR_DECLN',
    TestEmail = 'TEST_EMAIL',
    TestSms = 'TEST_SMS',
    BrandColor = 'BRAND_COLOR'
}

export default AppSetting;